import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SmsTransactionType } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'sms-transaction-type',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './sms-transaction-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsTransactionTypeComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  getMode(value: number) {
    if (!value || value == 0) return '-';
    else if (Object.keys(value).length == 0) {
      return '-';
    } else {
      return SmsTransactionType[value];
    }
  }
}
